import type { TFunction } from "i18next";
import type { AssessmentScope } from "@/hooks/types";

/** The limits a conclusion can be given under (Jira NAV-199), in the order the
 *  form offers them. Mirrors the backend's `AssessmentScope` and the three
 *  words `validAssessmentShape` admits. */
export const ASSESSMENT_SCOPES: readonly AssessmentScope[] = [
  "COMPANY_ACCOUNT_ONLY",
  "BROWSER_ONLY",
  "NAMED_TEAMS_ONLY",
];

/** A stored scope as the words this app knows, once each, in the form's
 *  order. A stored list is a claim (the backend writes past the rules), so
 *  anything else is dropped rather than rendered as a raw key or written back
 *  on the next save. */
export function knownScopes(value: unknown): AssessmentScope[] {
  if (!Array.isArray(value)) return [];
  return ASSESSMENT_SCOPES.filter((scope) => value.includes(scope));
}

/** The three limits as filter choices, labelled in the shared words the
 *  conclusion card uses (Jira NAV-220). Literal keys, so the locale checks
 *  that read call sites can see them. */
export function scopeFilterOptions(
  t: TFunction,
): { value: AssessmentScope; label: string }[] {
  const labels: Record<AssessmentScope, string> = {
    COMPANY_ACCOUNT_ONLY: t("common:assessment.scope.COMPANY_ACCOUNT_ONLY"),
    BROWSER_ONLY: t("common:assessment.scope.BROWSER_ONLY"),
    NAMED_TEAMS_ONLY: t("common:assessment.scope.NAMED_TEAMS_ONLY"),
  };
  return ASSESSMENT_SCOPES.map((value) => ({ value, label: labels[value] }));
}
